import { StateCreator } from 'zustand';

import { MAX_RECENT_MOVE_TARGETS } from '../../../utils/constants/brainConstants';
import {
  BrainRecentMoveTargetsSlice,
  BrainStore,
  INITIAL_BRAIN_STATE,
  RecentMoveTarget,
} from '../types';

function isSameMoveTarget(a: RecentMoveTarget, b: RecentMoveTarget): boolean {
  return (
    a.targetSpaceId === b.targetSpaceId &&
    a.targetParentPageId === b.targetParentPageId
  );
}

export const createRecentMoveTargetsSlice: StateCreator<
  BrainStore,
  [],
  [],
  BrainRecentMoveTargetsSlice
> = (set) => ({
  recentMoveTargets: INITIAL_BRAIN_STATE.recentMoveTargets,

  addRecentMoveTarget: (target) => {
    set((state) => {
      const deduped = state.recentMoveTargets.filter(
        (existing) => !isSameMoveTarget(existing, target),
      );
      return {
        recentMoveTargets: [target, ...deduped].slice(
          0,
          MAX_RECENT_MOVE_TARGETS,
        ),
      };
    });
  },
});
